import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './TagList.st.css.js';
import Tag from '../Tag';
import TagListAction from './TagListAction';
import ToggleMoreButton from './ToggleMoreButton';
import dataHooks from './dataHooks';
const tagToActionButtonSize = {
    small: 'tiny',
    medium: 'small',
    large: 'medium',
};
/** TagList */
class TagList extends React.PureComponent {
    constructor(props) {
        super(props);
        this._toggleExpanded = () => this.setState(prevState => ({ isExpanded: !prevState.isExpanded }));
        this._renderToggleMoreButton = () => {
            const { toggleMoreButton, tags, maxVisibleTags, size } = this.props;
            const { isExpanded } = this.state;
            const amountOfHiddenTags = tags.length - maxVisibleTags;
            if (toggleMoreButton && amountOfHiddenTags > 0) {
                return (React.createElement(ToggleMoreButton, { size: tagToActionButtonSize[size],
                    toggleMoreButton,
                    amountOfHiddenTags,
                    isExpanded, dataHook: dataHooks.toggleMoreButton, onClick: this._toggleExpanded }));
            }
            return null;
        };
        this.state = {
            isExpanded: props.initiallyExpanded,
        };
    }
    render() {
        const { dataHook, tags, actionButton, size, onTagRemove, maxVisibleTags } = this.props;
        const { isExpanded } = this.state;
        const visibleTags = isExpanded ? tags : tags.slice(0, maxVisibleTags);
        const actionButtonSize = tagToActionButtonSize[size];
        return (React.createElement("div", { className: classes.root, "data-hook": dataHook },
            visibleTags.map(({ className, ...tagProps }) => (React.createElement(Tag, { ...tagProps, className: st(classes.item, className), size: size, onRemove: onTagRemove, key: tagProps.id }))),
            this._renderToggleMoreButton(),
            actionButton && (React.createElement(TagListAction, { dataHook: dataHooks.actionButton, size: actionButtonSize, onClick: actionButton.onClick }, actionButton.label))));
    }
}
TagList.displayName = 'TagList';
TagList.propTypes = {
    /** Applies a data-hook HTML attribute to be used in the tests */
    dataHook: PropTypes.string,
    /** Lists all component’s tags and its properties */
    tags: PropTypes.arrayOf(PropTypes.object),
    /** Defines a callback function that passes an `id` property as a parameter when removing a tag */
    onTagRemove: PropTypes.func,
    /** Sets the size of a component */
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    /** Defines whether the list is:
     * - initially expanded (shows all tags)
     * - or collapsed (shows tags up to the max visible number)
     */
    initiallyExpanded: PropTypes.bool,
    /** Sets an amount of tags to show before expanding */
    maxVisibleTags: PropTypes.number,
    /** Defines the label of an action button and its onClick function */
    actionButton: PropTypes.shape({
        onClick: PropTypes.func,
        label: PropTypes.string,
    }),
    /** Defines a function which provides props for the ToggleMoreButton
     * ##### toggleMoreButton signature is:
     * `function(amountOfHiddenTags: number, isExpanded: boolean) => ToggleMoreButtonProps`
     *
     * ##### ToggleMoreButtonProps:
     * * `label`: string
     * * `tooltipContent`: node
     * * `tooltipProps`: TooltipCommonProps
     */
    toggleMoreButton: PropTypes.func,
};
TagList.defaultProps = {
    size: 'small',
    initiallyExpanded: false,
    maxVisibleTags: 3,
};
export default TagList;
//# sourceMappingURL=TagList.js.map